import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image/withIEPolyfill';
import styled from 'styled-components';
import { Grid, Typography, Button, Hidden } from '@material-ui/core';
import NewsLetterForm from '../forms/newsletter';
import Section from '../sections/section';

const FooterSection = styled(Section)`
  padding: 1rem 0 3rem 0;
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    padding: 1rem 1rem 3rem 1rem;
  }
`;

const Footer = styled.footer`
  background: ${props => props.theme.palette.primary.main};
`;

const FooterImage = styled(Img)`
  border-radius: 5px;
  margin: 1rem;
`;

const Newsletter = styled(Grid)`
  padding: 1rem;
  color: white;
`;

const Copyright = styled(Grid)`
  background: white;
  padding: 0 1rem;
`;

const Navigation = styled.ul`
  list-style: none;
  padding: 0.5rem;
  li,
  span {
    color: white;
    padding: 0 0.5rem;
    a {
      color: white;
      text-decoration: none;
    }
  }
`;

// const GridItem = styled(Grid)`
//   flex-direction: row-reverse;
// `;

const MyFooter = () => {
  const data = useStaticQuery(graphql`
    {
      sanitySettings {
        footerLogo {
          asset {
            fluid(maxWidth: 500) {
              ...GatsbySanityImageFluid
            }
          }
        }
        footerImage {
          asset {
            fluid(maxWidth: 500) {
              ...GatsbySanityImageFluid
            }
          }
        }
        copyright
        navigation {
          items {
            link {
              linkName
              page {
                ... on SanityAboutPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityContactPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityCustomPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityLandingPage {
                  id
                  name
                }
                ... on SanityServicesPage {
                  id
                  name
                  slug {
                    current
                  }
                }
              }
            }
            childLinks {
              page {
                ... on SanityAboutPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityContactPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityCustomPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityLandingPage {
                  id
                  name
                }
                ... on SanityServicesPage {
                  id
                  name
                  slug {
                    current
                  }
                }
              }
            }
          }
        }
      }
      sanityContactPage {
        socialLinkSection {
          socialLinks {
            name
            url
            iconImage {
              asset {
                fixed(width: 30) {
                  ...GatsbySanityImageFixed
                }
              }
            }
          }
        }
      }
    }
  `);

  const page = data.sanitySettings;
  const links = data.sanityContactPage.socialLinkSection.socialLinks;

  return (
    <Footer>
      <FooterSection
        maxWidth="lg"
        // disableGutters
        component={Grid}
        container
        direction="column"
      >
        <Grid
          item
          container
          justify="center"
          alignItems="center"
          component={Navigation}
        >
          {page.navigation.items.length
            ? page.navigation.items.map(
                (item, index) =>
                  item && (
                    <React.Fragment key={index}>
                      <Grid item component="li">
                        {item.link.page ? (
                          <Typography
                            variant="button"
                            component={Link}
                            to={
                              item.link.page.slug
                                ? `/${item.link.page.slug.current}`
                                : '/'
                            }
                          >
                            {item.link.linkName}
                          </Typography>
                        ) : (
                          <Typography variant="button">
                            {item.link.linkName}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item component="span">
                        <Typography variant="h6">|</Typography>
                      </Grid>
                    </React.Fragment>
                  )
              )
            : ''}
          {links.map((link, index) =>
            link.iconImage == null ? (
              ''
            ) : (
              <Grid item component="li" key={`socialLink${index}`}>
                <a href={link.url == null ? '' : link.url}>
                  <Img fixed={link.iconImage.asset.fixed} />
                </a>
              </Grid>
            )
          )}
        </Grid>
        <Grid
          item
          container
          justify="center"
          direction="row-reverse"
          alignItems="flex-end"
        >
          <Newsletter
            xs={12}
            sm={6}
            md={4}
            item
            container
            alignItems="center"
            justify="space-between"
          >
            <NewsLetterForm />
          </Newsletter>
          <Grid item xs={12} sm={6} md={4}>
            {page.footerImage == null ? (
              ''
            ) : (
              <FooterImage fluid={page.footerImage.asset.fluid} alt="CPPS" />
            )}
          </Grid>
          <Hidden smDown>
            <Grid item md={4}>
              {page.footerLogo == null ? (
                ''
              ) : (
                <FooterImage fluid={page.footerLogo.asset.fluid} alt="CPPS" />
              )}
            </Grid>
          </Hidden>
        </Grid>
      </FooterSection>
      <Copyright item container justify="space-between" alignItems="center">
        <Typography variant="button" color="primary">
          &copy; {page.copyright ? page.copyright : '2020'}
        </Typography>
        <Button component={Link} to="/privacy" size="small" color="primary">
          Privacy Policy
        </Button>
      </Copyright>
    </Footer>
  );
};

export default MyFooter;
